<template>
  <div
    class="rounded-md border transition-colors relative"
    :class="{
      'border-nami-comi-blue glow-animation': highlighted,
      'border-neutral-300 dark:border-neutral-700': !highlighted,
    }"
  >
    <div class="flex flex-col justify-between h-full">
      <div class="space-y-4 mb-4">
        <AsyncImage
          class="w-full h-32 object-cover rounded-md"
          :src="banner ?? getAbsoluteAssetLink('nami/banner/rising-sun.png')"
        />
        <h3 class="text-2xl sm:text-3xl text-center font-medium">
          {{ title }}
        </h3>
        <div
          class="text-center text-sm sm:text-base text-neutral-700 dark:text-neutral-300"
        >
          ${{ price }}/month
        </div>
        <ul class="px-4 space-y-1 max-w-[24rem] mx-auto">
          <li
            v-for="feature in features"
            class="text-sm sm:text-base text-center"
          >
            {{ feature }}
          </li>
          <li
            v-if="features.length === 0"
            class="text-sm sm:text-base italic text-center text-neutral-500"
          >
            {{ $t("components.subscriptionCard.noBenefitsText") }}
          </li>
        </ul>
      </div>
      <NamiButton
        class="mx-auto"
        buttonType="primary"
        small
        text
        :href="href.org.slug.rewards(orgSlug) + `?tier=${id}`"
      >
        See All Rewards
      </NamiButton>
      <div class="mt-4 mb-4 mx-4">
        <p
          v-if="subscribedToId === id"
          class="text-sm sm:text-base text-center text-nami-comi-blue"
        >
          {{ $t("components.subscriptionCard.thankYouText") }}
        </p>
        <NamiButton
          v-else
          v-if="!disabled"
          buttonType="primary"
          @buttonClick="emit('select')"
          :icon="IconArrowRight"
          iconPosition="right"
          small
          block
          :disabled="!!subscribedToId"
        >
          {{ $t("components.subscriptionCard.buttonSelect") }}
        </NamiButton>
      </div>
    </div>
    <div
      v-if="highlighted"
      class="absolute -top-3 left-0 h-6 w-full flex justify-center items-center"
    >
      <span
        class="rounded-full py-1 px-4 font-medium text-center text-xs border border-nami-comi-blue bg-neutral-800 dark:bg-neutral-50 dark:text-black text-white"
      >
        {{ highlightText ?? $t("components.subscriptionCard.creatorRecText") }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconArrowRight } from "@tabler/icons-vue";

defineProps<{
  orgSlug: string;
  id: string;
  title: string;
  price: number;
  features: string[];
  highlighted?: boolean;
  highlightText?: string;
  banner?: string | null;
  subscribedToId?: string;
  disabled?: boolean;
}>();

const href = useHref();

const emit = defineEmits<{
  (e: "select"): void;
}>();
</script>

<style scoped>
ul li::marker {
  color: rgb(196, 196, 196);
}

.dark ul li::marker {
  color: rgb(128, 128, 128);
}

.glow-animation {
  animation: glow 1.5s ease-out infinite;
}

@keyframes glow {
  0% {
    box-shadow: 0 0 15px #02c3ff11;
  }
  50% {
    box-shadow: 0 0 15px #02c3ffff;
  }
  100% {
    box-shadow: 0 0 15px #02c3ff11;
  }
}
</style>
